// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_dqk","cls2":"AuthorHeader-cls2_jOp AuthorHeader-cls1_dqk"};